import React from 'react';
import styled from 'styled-components';
import { MDXProvider } from '@mdx-js/react';
import { CookiesProvider } from 'react-cookie';
import { Header } from './Header';
import { Footer } from './Footer';
import { CookieConsent } from './CookieConsent';
import { theme } from '../theme';
import { useDynamicOverflow } from '../utils';

import { allEditorComponents } from './editorComponents';

export function Layout({ children, hideFooterContactForm }) {
  useDynamicOverflow(theme.headerTopBarBackgroundColor, theme.footerBackgroundColor);

  return (
    <CookiesProvider>
      <Wrapper>

        <a href="#c" id="skipToContent" tabIndex="0">Gå til indhold »</a>

        <Header />

        <MDXProvider components={allEditorComponents}>
          <main id="c">{children}</main>
        </MDXProvider>
        <Footer hideContactForm={hideFooterContactForm} />

        <CookieConsent />
      </Wrapper>
    </CookiesProvider>
  );
}

const Wrapper = styled.div`
  min-height: 100vh;
`;
